import { useQuery } from 'react-query';
import { ServerStateKeysEnum } from 'reactQuery/constants';
import { dsoCartService } from 'services';

export const useDsoFetchPermissions = () =>
  useQuery(
    ServerStateKeysEnum.dsoPermissions,
    () => dsoCartService.fetchDsoPermissions(),
    {
      staleTime: Infinity,
      onError: error => {
        console.error(error);
      },
    }
  );
